import { MagnifyingGlassIcon } from "@heroicons/react/20/solid"
import Button from "@src/components/Button"

interface ModalNoResultsProps {
  handleSearchClear: () => void
  text?: string
}

const ModalNoResults = ({
  handleSearchClear,
  text = "No tokens found",
}: ModalNoResultsProps) => (
  <div className="my-8 flex flex-col items-center justify-center">
    <div
      className="flex size-10 items-center justify-center rounded-full bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-400"
      aria-hidden
    >
      <MagnifyingGlassIcon className="size-5" />
    </div>
    <h3 className="mt-4 font-semibold text-base text-gray-900 dark:text-white">
      {text}
    </h3>
    <Button size="md" onClick={handleSearchClear} className="mt-4">
      Clear search
    </Button>
  </div>
)

export default ModalNoResults
